import styled from 'styled-components';

export const StyledFakeLabel = styled.span`
  display: block;
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  line-height: 1;
  color: ${({ $labelColor, $disabled }) => ($disabled ? 'var(--text-color)' : $labelColor || 'var(--black)')};
  /* color: var(--black); */
`;

export const RequiredAsterisk = styled.span`
  color: var(--danger);
  margin-left: 3px;
`;
